import { render, staticRenderFns } from "./SellerCreate.vue?vue&type=template&id=64eb8f42&"
import script from "./SellerCreate.vue?vue&type=script&lang=js&"
export * from "./SellerCreate.vue?vue&type=script&lang=js&"
import style0 from "./SellerCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports